import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRouter from 'vue-router'
import request from '../src/utils/request'
// import 'normalize.css/normalize.css'
import './permission'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import '@/styles/index.scss'
import { jsonFormData,timeDay,nowTime,forinlist } from './utils/jsonFormData';
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
import crypto from '@/utils/crypto'
import cryptoadd from '@/utils/cryptoadd'
// import echarts from "echarts";
import * as echarts from 'echarts';
Vue.use(VideoPlayer)
import VEmojiPicker from 'v-emoji-picker'
Vue.use(VEmojiPicker)
/* 引入swiper */
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
// Vue.use(VueAwesomeSwiper /* { default options with global component } */)

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'NZPsOGbToP4dfmQdST8WA0nQKGFLGuDA'
})


Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.prototype.$form = jsonFormData;
Vue.prototype.$timeDay = timeDay;
Vue.prototype.$crypto = crypto;
Vue.prototype.$cryptoadd = cryptoadd;
Vue.prototype.$http = request;
// Vue.prototype.$url = process.env.NODE_ENV === 'development' ? 'https://jwsxgc.suchengkeji.cn' : 'https://jwsxgc.suchengkeji.cn';
// Vue.prototype.$url = process.env.NODE_ENV === 'development' ? 'https://192.168.9.223' : 'https://192.168.9.223';
Vue.prototype.$url = process.env.NODE_ENV === 'development' ? 'https://192.168.30.119' : 'https://192.168.30.119';
import jquery from 'jquery'
Vue.prototype.$ = jquery
Vue.prototype.$echarts = echarts;

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
